var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 123,
    viewBox: "0 0 138 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6025_918)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1999 119.906C80.6352 119.906 95.5799 104.961 95.5799 86.5255C95.5799 68.0902 80.6352 53.1455 62.1999 53.1455C43.7647 53.1455 28.8199 68.0902 28.8199 86.5255C28.8199 104.961 43.7647 119.906 62.1999 119.906Z",
    fill: "#00A5D5"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9699 34.4053C75.7899 34.4053 82.9399 27.2553 82.9399 18.4353C82.9399 9.61535 75.7899 2.46533 66.9699 2.46533C58.15 2.46533 50.9999 9.61535 50.9999 18.4353C50.9999 27.2553 58.15 34.4053 66.9699 34.4053Z",
    fill: "#FFDF00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.42 56.2154C108.52 56.2154 119.14 45.5956 119.14 32.4954C119.14 19.3952 108.52 8.77539 95.42 8.77539C82.3198 8.77539 71.7 19.3952 71.7 32.4954C71.7 45.5956 82.3198 56.2154 95.42 56.2154Z",
    fill: "#FF009D"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.96 13.9751L0.959961 59.0851V122.395H64.14L94.96 90.9751",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7499 78.3651L109.14 1.24512",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.92 75.9451L137.58 1.24512",
    stroke: "black",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6025_918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.47,
    height: 122,
    fill: "white",
    transform: "translate(0.459961 0.89502)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicLogo3);
export default __webpack_public_path__ + "static/media/graphic-logo-3.a56792c8ca6d178c08a1c06268054765.svg";
export { ForwardRef as ReactComponent };